import { Exit, NPCharacter, Player } from "../objects";
import { translate } from "../../utils/localization";
import template from "lodash.template";
import levelGoalKit from "./levelGoalKit";

class Level6 extends levelGoalKit {
  constructor() {
    super();
    this.name = "The deal";
    this.diamondsGoal = 10;
    this.dwarfRun = false;
    this.preventDisplayDiamondsGoalAmount = true;
    this.diamondIdTriggerDwarfMove = 4;
    this.exit = null;
  }

  get id() {
    return this.constructor.key
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);

    if (this.unfinished) {
      this.goalCheckPoint.ephemeral = true

      // set up Dwarf teleport trigger
      const listenPostitionForDwarfTeleport = nextPos => {
        if(nextPos.x < 4 && nextPos.y > 17) {
          const nextPos = { x: this.exit.position.x - 3, y: this.exit.position.y };
    
          // teleport dwarf
          this.teleportObject(this.leader, nextPos)
          console.log('TELEPORT');
          // -----
    
          // adjust interactive tile to talk about angel once or about jewels each time player steps on
          if (
            !this.interactiveElements[
              `${this.goalCheckPoint.position.x}-${this.goalCheckPoint.position.y}`
            ]
          ) {
            // restore erased interactive tile
            this.goalCheckPoint.ephemeral = false;
            this.interactiveElements[
              `${this.goalCheckPoint.position.x}-${this.goalCheckPoint.position.y}`
            ] = this.goalCheckPoint;
          } else {
            // make it permanent
            this.goalCheckPoint.ephemeral = false;
          }

        } else {
          this.scene.events.once("player_moves", nextPos => listenPostitionForDwarfTeleport(nextPos))
        }
      }
      
      this.scene.events.once("player_moves", nextPos => listenPostitionForDwarfTeleport(nextPos))
    }
  }

  onInteractWith(el) {
    super.onInteractWith(el);
    // talk to Doc
    if (el.order === 0 && this.unfinished) {
      this.showDialog1();
    }
    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

    if (el.isClass(Exit)) {
      this.exit = el;
    }

    if (el.isClass(NPCharacter)) {
      el.leadingPath = [
        // 10, 8
        { x: 10, y: 9 },
        { x: 11, y: 9 },
        { x: 12, y: 9 },
        { x: 12, y: 10 },
        { x: 12, y: 10 },
        { x: 12, y: 10 },
        { x: 13, y: 11 },
        { x: 13, y: 11 },
        { x: 13, y: 11 },
        { x: 14, y: 12 },
        { x: 15, y: 12 },
        { x: 16, y: 12 },
        { x: 17, y: 12 },
        { x: 18, y: 12 },
        { x: 18, y: 11 },
        { x: 19, y: 11 },
        { x: 20, y: 11 },
        { x: 21, y: 11 },
        { x: 22, y: 11 },
        { x: 23, y: 11 },
        { x: 24, y: 11 },
        { x: 25, y: 11 },
        { x: 26, y: 11 },
        { x: 27, y: 11 },
        { x: 28, y: 11 },
        { x: 29, y: 11 },
        { x: 30, y: 11 },
      ];
      el.isCloseEnough = () => this.dwarfRun;
    }
  }

  showDialog1() {
    this.scene.events.once("dialogue:hidden", () => {
      // this.scene.events.emit("score:diamond_goal_set", this.diamondsGoal);
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Dwarf", "closeUp_Mary"],
      participantNames: ["???", "Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_6.dialog_1.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_1.mary_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_6.dialog_1.dwarf_say_2")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_1.mary_say_3")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_6.dialog_1.dwarf_say_3")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_1.mary_say_4")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_6.dialog_1.dwarf_say_4")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_6.dialog_1.dwarf_say_5")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_1.mary_say_5")],
        },
      ],
    });

    this.scene.events.once("dialogue:hidden", () => {
      this.player.disconnect();
      this.dwarfRun = true;
      this.moveDwarf();
    });
  }
  showDialogAngel() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ["Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_2.mary_say_1")],
        },
      ],
    });
  }
  moveToExit() {
    this.scene.events.on("dialogue:message_shown", (pageId) => {
      if (pageId === 2) {
        this.scene.events.emit("dialogue:updateCharacterName", {
          key: "closeUp_Dwarf",
          name: "Doc",
        });
      }
    });
    this.scene.events.once("dialogue:hidden", () => {
      super.moveToExit();
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "???"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_3.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_6.dialog_3.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_6.dialog_3.mary_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_6.dialog_3.dwarf_say_2")],
        },
      ],
    });
  }

  showDialogGoal() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "???"],
      conversation: [
        {
          who: "closeUp_Dwarf",
          text: [
            template(translate("levels.goal_dialog.dwarf_say_1"))({
              GOAL: this.diamondsGoal,
              NUM: this.collectedDiamonds,
            }),
          ],
        },
      ],
    });
  }

  moveDwarf() {
    // hack to auto move dwarf until pos x is 10
    if (this.dwarfRun) {
      if (this.leader.position.x < 16) {
        this.leader.onPlayerMoves(this.player.position);
        this.onNextTick(() => {
          this.leader.animIdle();
          this.moveDwarf();
        });
      } else {
        this.leader.animIdle();
        // auto pilot off
        this.player.reconnect();
        setTimeout(() => this.scene.events.emit("score:diamond_goal_set", this.diamondsGoal), 1000);

        // listen for player move until dwarf reach last position of path, then
        // remove fix of dwarfRun and remove listener
        const onPlayerMove = (() => {
          if (this.leader.position.x >= 30) {
            this.dwarfRun = false;
            this.scene.events.removeListener("player_moves", onPlayerMove);
          }
        }).bind(this);
        this.scene.events.addListener("player_moves", onPlayerMove);
      }
    }
  }

  moveDwarfToExit() {
    // hack to auto move dwarf until pos x is 10
    if (this.dwarfRun) {
      if (this.leader.position.x < this.exit.position.x) {
        this.onNextTick(() => {
          this.leader.onPlayerMoves(this.player.position);
          this.moveDwarfToExit();
        });
      } else {
        this.leader.animIdle();
        // auto pilot off
        this.player.reconnect();
      }
    }
  }
}

Level6.key = "level_6";
export default Level6;
